// import { getWindowOrigin } from "@helper/utils";
// import { DotLottie } from "@lottiefiles/dotlottie-web";
// import { useEffect, useState } from "react";

import { Link } from "react-router";

export default function FestivalBanner() {
  /* const [lottieReady, setlottieReady] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setlottieReady(1);
    }, 800);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && lottieReady) {
      const canvasDoc = document.getElementById("dotlottie-canvas");

      if (canvasDoc instanceof HTMLCanvasElement) {
        const width = canvasDoc.offsetWidth || 1024;
        const BASE_URL = getWindowOrigin();
        const CelebrationAnimation =
          BASE_URL + "/web2-assets/christmas-banner.lottie";
        const CelebrationAnimationTablet =
          BASE_URL + "/web2-assets/christmas-banner-tablet.lottie";

        new DotLottie({
          autoplay: true,
          loop: true,
          canvas: canvasDoc,
          src: width <= 768 ? CelebrationAnimationTablet : CelebrationAnimation, // lottie or .json file
          layout:
            width <= 1024
              ? { fit: "cover", align: [0.5, 0.5] }
              : { fit: "fill", align: [0, 0] },
        });
        const height_ratio = width > 768 ? 0.105 : width > 575 ? 0.143 : 0.2;
        const minCanvasHeight = (width > 768 ? 170 : 110) + "px";
        canvasDoc.style.height = width * height_ratio + "px";
        canvasDoc.style.minHeight = minCanvasHeight;
      }
    }
  }, [lottieReady]);*/

  return (
    <>
      <div className="festival-bg xl:max-w-[1440px] w-full mx-auto lg:p-0 flex items-center justify-center">
        <div className="festival-text text-white-100 text-center">
          தமிழ் முரசின் இனிய தீபாவளி நல்வாழ்த்துகள்! <br />
          <Link
            to="/keywords/deepavali-2025"
            className="text-xs font-bold leading-[120%] underline"
            reloadDocument
          >
            தீபாவளி தொடர்பான செய்திகள், காணொளிகளுக்கு!
          </Link>
        </div>
      </div>

      {/* <div className="w-auto">
        <canvas id="dotlottie-canvas" className="w-[100%]"></canvas>
      </div> */}
    </>
  );
}
